export default "__VITE_ASSET__5f4c6e2a__"